import React, { useEffect, useState } from 'react';
import { META_AD_TYPE } from '../SocialMediaConstant';

const FacebookFeedAd = ({
    image,
    message,
    buttonType,
    link
}) => {
    link = link?.trim();
    const [tagline, setTagline] = useState("Visit Website");
    const [publisher, setPublisher] = useState("brightmediasolution.com");

    useEffect(() => {
        if (!link) {
            setPublisher("brightmediasolution.com");
            setTagline("Visit Website");
            return;
        }
        fetchTagline();
    }, [link]);

    const fetchTagline = async () => {
        try {
            const response = await fetch(`https://api.microlink.io/?url=${encodeURIComponent(link)}`);
            const res = await response.json();
            if (res && res.data) {
                setPublisher(res.data.publisher || res.data.author || new URL(link).hostname || "brightmediasolution.com");
                setTagline(res.data.title || "Visit Website");
            } else {
                setPublisher(new URL(link).hostname || "brightmediasolution.com");
                setTagline("Visit Website");
            }
        } catch (e) {
            try {
                setPublisher(new URL(link).hostname || "brightmediasolution.com");
            } catch (_) {
                setPublisher("brightmediasolution.com");
            }
            setTagline("Visit Website");
        }
    };

    const displayImage = image || 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=600&auto=format&fit=crop';

    return (
        <div style={{
            width: '100%',
            maxWidth: '340px',
            border: '1px solid #dee2e6',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            overflow: 'hidden',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            backgroundColor: '#ffffff',
            transition: 'transform 0.2s, box-shadow 0.2s',
        }}>
            {/* Header */}
            <div style={{
                display: 'flex', 
                alignItems: 'center', 
                padding: '12px', 
                borderBottom: '1px solid #f0f2f5'
            }}>
                <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    backgroundColor: '#1877f2',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '8px',
                    color: 'white',
                    fontSize: '1rem'
                }}>
                    <i className='fa fa-brands fa-facebook' />
                </div>
                <span style={{ fontSize: '0.8rem', fontWeight: '600', color: '#050505' }}>Facebook Feed</span>
            </div>

            {/* Publisher details */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                padding: '12px 12px 8px 12px',
            }}>
                <img
                    src="https://bmsinfoglobal.com/wp-content/uploads/2023/05/bmslogo2.png"
                    alt="Logo"
                    style={{ 
                        width: '36px', 
                        height: '36px', 
                        borderRadius: '50%', 
                        marginRight: '10px',
                        border: '1px solid #e9ecef',
                        objectFit: 'contain',
                        backgroundColor: '#fff'
                    }}
                />
                <div style={{ flex: 1, minWidth: 0 }}>
                    <h4 style={{ fontSize: '0.825rem', fontWeight: '700', margin: 0, color: '#050505', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        Bright Media Solution
                    </h4>
                    <div style={{ fontSize: '0.7rem', color: '#65676b', display: 'flex', alignItems: 'center', gap: '4px', marginTop: '2px' }}>
                        <span>Sponsored</span>
                        <span>•</span>
                        <i className='fa fa-globe' style={{ fontSize: '0.75rem' }} />
                    </div>
                </div>
                <button style={{ background: 'none', border: 'none', color: '#65676b', cursor: 'pointer', padding: '4px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>•••</span>
                </button>
            </div>

            {/* Message */}
            {message ? (
                <p style={{ 
                    padding: '4px 12px 12px 12px', 
                    fontSize: '0.825rem', 
                    color: '#050505', 
                    margin: 0,
                    lineHeight: '1.4',
                    whiteSpace: 'pre-wrap'
                }}>
                    {message}
                </p>
            ) : (
                <p style={{ 
                    padding: '4px 12px 12px 12px', 
                    fontSize: '0.825rem', 
                    color: '#8a8d91', 
                    margin: 0,
                    fontStyle: 'italic'
                }}>
                    Enter ad message...
                </p>
            )}

            {/* Media container */}
            <div style={{
                width: '100%',
                height: '190px',
                backgroundColor: '#f0f2f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                borderTop: '1px solid #f0f2f5',
                borderBottom: '1px solid #f0f2f5'
            }}>
                <img
                    src={displayImage}
                    alt="Ad Creative"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                    }}
                />
            </div>

            {/* CTA Info Banner */}
            <div style={{ 
                padding: '12px', 
                backgroundColor: '#f0f2f5', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                gap: '8px'
            }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <span style={{ 
                        fontSize: '0.675rem', 
                        color: '#65676b', 
                        textTransform: 'uppercase',
                        display: 'block',
                        letterSpacing: '0.5px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>
                        {publisher}
                    </span>
                    <h5 style={{ 
                        fontSize: '0.85rem', 
                        fontWeight: '600', 
                        color: '#050505', 
                        margin: '2px 0 0 0',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: '2',
                        WebkitBoxOrient: 'vertical',
                        lineHeight: '1.25'
                    }}>
                        {tagline}
                    </h5>
                </div>
                <button
                    style={{
                        padding: '6px 14px',
                        fontSize: '0.75rem',
                        backgroundColor: '#e4e6eb',
                        color: '#050505',
                        borderRadius: '6px',
                        fontWeight: '600',
                        border: 'none',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        transition: 'background-color 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#d8dadf'}
                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e4e6eb'}
                >
                    {META_AD_TYPE[buttonType] || buttonType || 'Learn More'}
                </button>
            </div>

            {/* Action Bar */}
            <div style={{
                borderTop: '1px solid #e5e5e5',
                display: 'flex',
                justifyContent: 'space-around',
                padding: '6px 0',
                fontSize: '0.75rem',
                color: '#65676b',
                fontWeight: '600',
            }}>
                <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '4px' }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f2f5'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                    <i className="fa fa-thumbs-o-up" style={{ fontSize: '0.85rem' }} /> Like
                </span>
                <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '4px' }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f2f5'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                    <i className="fa fa-comment-o" style={{ fontSize: '0.85rem' }} /> Comment
                </span>
                <span style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', padding: '6px 12px', borderRadius: '4px' }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0f2f5'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                    <i className="fa fa-share" style={{ fontSize: '0.85rem' }} /> Share
                </span>
            </div>
        </div>
    );
};

export default FacebookFeedAd;
